import { defineRouting } from 'next-intl/routing'

import { DEFAULT_LANG, LOCALES } from '@/config/constants'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: LOCALES,
  localePrefix: 'as-needed',
  localeDetection: false,

  // Used when no locale matches
  defaultLocale: DEFAULT_LANG,
})
